export * from './numericListTextResultEntryScreen.service';